import { Component, OnInit } from '@angular/core';
import {
  trigger,
  transition,
  useAnimation,
  style,
  state
} from '@angular/animations';
import { fadeIn, fadeOut } from 'ng-animate';
import {
  HousingDataService,
  ApprovedHousingComplex,
  AcademicSession,
  ChurchUnitsDataService,
  CampusWard,
  LocalWard,
  CampusStake
} from '../../shared';
import { forkJoin } from 'rxjs';
import { finalize } from 'rxjs/operators';

// used in our animations
const fadeInParams = { params: { timing: 0.65 } };
const fadeOutParams = { params: { timing: 0.25, delay: 0 } };

@Component({
  templateUrl: './lookup.component.html',
  styleUrls: ['./lookup.component.scss'],
  animations: [
    trigger('unitTypeState', [
      state('non-ysa', style({ display: 'none' })),
      transition('* => ysa-ward', useAnimation(fadeIn, fadeInParams)),
      transition('* => non-ysa', useAnimation(fadeOut, fadeOutParams))
    ]),
    trigger('showYsaHomeWard', [
      state('ysa-non-home-ward', style({ display: 'none' })),
      state('non-ysa', style({ display: 'none' })),
      transition('* => ysa-home-ward', useAnimation(fadeIn, fadeInParams)),
      transition('* => non-ysa', useAnimation(fadeOut, fadeOutParams))
    ]),
    trigger('hideYsaHomeWard', [
      state('ysa-home-ward', style({ display: 'none' })),
      state('non-ysa', style({ display: 'none' })),
      transition('* => ysa-non-home-ward', useAnimation(fadeIn, fadeInParams)),
      transition('* => non-ysa', useAnimation(fadeOut, fadeOutParams))
    ]),
    trigger('fade', [
      transition(':enter', useAnimation(fadeIn, fadeInParams)),
      transition(':leave', useAnimation(fadeOut, fadeOutParams))
    ])
  ]
})
export class LookupComponent implements OnInit {
  // options for our radio buttons
  unitType = 'ward';
  unitMaritalType = 'single';
  localWardOnly = false;

  // spinner flag
  loading = false;

  // housing state; selected complex, list of complexes to select from, whether or not we had errors loading the housing data
  housingComplexes: ApprovedHousingComplex[] = null;
  academicSessions: AcademicSession[] = null;

  // church units
  campusWards: CampusWard[];
  campusStakes: CampusStake[];
  localWards: LocalWard[];

  /* Constructor */
  constructor(
    private housingService: HousingDataService,
    private churchService: ChurchUnitsDataService
  ) {}

  /**
   * Gets the animation state our component should be in based on the selected unit types and unit marital types.
   */
  getUnitTypeState(): string {
    return this.unitMaritalType === 'single' && this.unitType === 'ward'
      ? 'ysa-ward'
      : 'non-ysa';
  }

  /**
   * Gets the animation state our component should be in based on whether or not the user wants home units.
   */
  getYsaHomeWardState(): string {
    if (this.unitMaritalType === 'single' && this.unitType === 'ward') {
      return this.localWardOnly ? 'ysa-home-ward' : 'ysa-non-home-ward';
    }

    return 'non-ysa';
  }

  /**
   * When our component loads, load supporting data that we need; show a spinner while we do this.
   */
  ngOnInit() {
    this.loading = true;
    forkJoin([this.housingService.getCurrentApprovedHousingComplexes(),
      this.housingService.getAcademicSessions(),
      this.churchService.getCampusWards()]
    )
    .pipe(
      finalize(() => this.loading = false)
    )
    .subscribe(([complexes, sessions, campusWards]) => {
        this.housingComplexes = complexes;
        this.academicSessions = sessions;

        // this.localWards = churchUnits.localWards;
        this.campusWards = campusWards;
        // this.campusStakes = churchUnits.campusStakes;
      });
  }

  getLocalWards() {
    if (this.localWards == null) {
      this.churchService
        .getLocalWards()
        .subscribe(localWards => (this.localWards = localWards));
    }
  }

  getCampusStakes() {
    if (this.campusStakes == null) {
      this.churchService
        .getCampusStakes()
        .subscribe(campusStakes => (this.campusStakes = campusStakes));
    }
  }
}
